<template>
  <div class="content" v-loadmore="loadMore">
    <div class="item border-bottom" v-for="(item , index) in list" :key="index">
      <div>
        <span class="left fs-32">提现</span>
        <span class="right fs-30">￥{{item.amount}}</span>
      </div>
      <div>
        <span class="left fs-26 c-999">{{item.date}}</span>
        <span class="right fs-24 c-999" :class="{'c-999':item.status===1,'light':item.status===0}">{{item.status===1?'已完成':'处理中'}}</span>
      </div>
    </div>
    <!-- <div class="item border-bottom">
      <div>
        <span class="left fs-32">提现</span>
        <span class="right fs-30">￥800</span>
      </div>
      <div>
        <span class="left fs-26 c-999">2018-6-16 14:30:41</span>
        <span class="right fs-24 light">处理中</span>
      </div>
    </div> -->
    <div class="no-record" v-if="no">暂无提现记录</div>
    <loading :more="more" :loaded="loaded" v-if="!no"></loading>
  </div>
</template>
<script type="text/ecmascript-6">
import Scroll from 'components/base/scroll/scroll'
import Loading from 'components/base/loading/loading2'
import {getUserWithdraw} from '@/api/user-center.js'
import {RES_OK} from '@/api/config'
export default {
  components: {
    Scroll,
    Loading
  },
  data() {
    return {
      page: 1,
      list: [],
      loaded: true,
      more: true,
      no: false
    }
  },
  created() {
    this.loadMore()
  },
  methods: {
    _getUserWithdraw() {
      getUserWithdraw(this.page).then((res) => {
        let data = res.data
        if (data && data.code === RES_OK && data.data) {
          if (data.data.length) {
            this.list.push(...data.data)
            this.loaded = true
            this.page++
          } else {
            // 加载完毕
            this.more = false
          }
          if (this.list.length === 0) {
            this.no = true
          }
        }
      })
    },
    loadMore() {
      if (this.more && this.loaded) {
        this.loaded = false
        this._getUserWithdraw()
      }
    }
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .content
    padding-bottom size(40)
  .item
    padding size(28) size(30)
    color #333
    >div:last-child
      margin-top size(12)
  .right
    float right
  .fs-32
    font-size size(32)
  .fs-30
    font-size size(30)
  .fs-26
    font-size size(26)
  .fs-24
    font-size size(24)
  .c-999
    color #999
  .light
    color $color-theme
  .no-record
    font-size size(30)
    text-align center
    color #999
    padding size(60)
</style>



// WEBPACK FOOTER //
// src/components/personal/wallet/wallet-tx-record.vue